module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.d3e528d9.woff";